import { useState } from 'react';
import { rankingBoards } from '@/mocks/homeData';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-400',
  down: 'ri-arrow-down-line text-secondary-300',
  flat: 'ri-subtract-line text-foreground-500',
};

export default function RankingBoard() {
  const [active, setActive] = useState(rankingBoards[0].key);
  const board = rankingBoards.find((b) => b.key === active) ?? rankingBoards[0];

  return (
    <section id="ranking" className="bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-medium tracking-wide text-primary-300">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400"></span>
              电影排行榜 · 多维度
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-background-50">
              金桔影院电影排行榜，按你的目的挑榜看
            </h2>
            <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-300">
              想看大家都在追的、想找经得起细看的、还是只想追最新上线的，切换下面的榜单即可对号入座。
            </p>
          </div>

          <div className="inline-flex items-center gap-1 rounded-full bg-foreground-900 p-1">
            {rankingBoards.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setActive(item.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition cursor-pointer ${
                  active === item.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-300 hover:text-background-50'
                }`}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>

        <p className="mt-6 text-sm text-foreground-400">{board.desc}</p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
          {board.items.map((row) => (
            <div
              key={`${board.key}-${row.rank}`}
              className="group flex items-center gap-4 border-b border-foreground-800 py-4"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-md font-heading text-sm font-bold ${
                  row.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-foreground-800 text-foreground-300'
                }`}
              >
                {row.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-heading text-base font-medium text-background-50">{row.title}</p>
                <p className="mt-0.5 text-xs text-foreground-400">{row.meta}</p>
              </div>
              <span className="inline-flex items-center gap-1">
                <i className={`${trendIcon[row.trend]} text-sm`}></i>
              </span>
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-sm"></i>
                </span>
                {row.score}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}